import { render, staticRenderFns } from "./Pesquisar.vue?vue&type=template&id=082c72e9&"
import script from "./Pesquisar.vue?vue&type=script&lang=js&"
export * from "./Pesquisar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports